module.exports = __webpack_public_path__ + "static/media/blackfin-scad.d273b142.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/blackfin-scad.png
// module id = 300
// module chunks = 0